import { ItfProductI18n } from './type';

const _i18n: Record<string, ItfProductI18n> = {
    en: {
        also_like: 'You might also like',
        view_more: 'View more',
        learn_more: 'Learn More',
    },
    nl: {
        also_like: 'Misschien ook interessant',
        view_more: 'Meer informatie',
        learn_more: 'Meer informatie',
    },
};

export const getI18n = (locale: string): ItfProductI18n => _i18n?.[locale] || _i18n['en'];
